<template>
    <template v-if="!isDataLoading">
        <div class="quiz__container">
            <div class="quiz__subtitle">{{ question }}</div>

            <div class="quiz__answers">
                <button v-for="(answer, index) in answers" :key="index" @click="checkAnswer(answer)" :class="['btn btn--choice', {'disabled': disable}, addClasses(answer)]">
                    <span>{{ answer.answer }}</span>
                </button>
            </div>
        </div>

        <progress-bar :totalCount="progressTotalCount" :current="progressCurrent"></progress-bar>
    </template>
</template>

<script>
import ProgressBar from '@/components/quiz/ProgressBar.vue';

export default {
    name: 'QuizQuestions',
    components: {
        ProgressBar
    },
    props: [
        'question', 
        'answers', 
        'checkAnswer', 
        'addClasses', 
        'disable', 
        'progressTotalCount', 
        'progressCurrent', 
        'isDataLoading'
    ],
    computed: {
        apiUri() {
            return process.env.VUE_APP_APOLLO_API_URI;
        }
    }
}
</script>
